import React, { useContext } from 'react';
import { ContentCarritoCompra } from '../../components/carritoCompra/ContentCarritoCompra';
import { MiFooter } from "../../components/footer/MiFooter";
import Header from "../../components/headers/Header";
import { UsuarioContext } from '../../contexts/UsuarioContext';
import './carritoCompra.css';

export const CarritoCompra = () => {

  /* A hook that is used to change the state of the menu. */
  const [MenuLateral, setMenuLateral] = useContext(UsuarioContext)
  const closeMenu = () => {
    if (MenuLateral === true) {
      setMenuLateral(false)
    }
  }
  return (
    <div className="carritoCompra" onClick={closeMenu}>
      <div className="headerCarritoCompra">
        <Header />
      </div>
      <div className="bodyCarritoCompra">
        <ContentCarritoCompra />
      </div>
      <div className="footerCarritoCompra">
        <MiFooter />
      </div>
    </div>
  )
}
